import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n/i18n"; // Initialize i18n
import App from "@/App";
import { registerServiceWorker } from "@/pwa/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Network-only shell (no caching); registered in all environments so phone alerts work.
registerServiceWorker();
